import React, { Component } from 'react';
import * as API from './api.js';
import './style.css';
import Loader from './icons/loader.svg';
import Search from "./Icon/Search.png";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CopyIcon from './icons/copy.png'
import Edit from './icons/pen.png'
import CopyActiveIcon from './icons/tick.png'
import fail from './assets/error.png';
import { Link, StaticRouter, Redirect } from 'react-router-dom';
import moment from 'moment';
import { Switch, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import btnAdd from './icons/btnAdd.svg';
import { AnimatedModal } from './ReusableComponents/AnimatedModal.js'
import closeButton from './close-button.png';
import dateFormat from 'dateformat';
import { ActivityPopup } from './ReusableComponents/ActivityPopup.js';

export default class TaskAndVmList extends Component {

    state = {
        user: {},
        type: "",
        vms: [],
        addVMPopup: false,
        vm_name: null,
        ip_address: null,
        status: false,
        az_subscription_id: null,
        resource_group: null,
        available: false,
        tasktype: 1,
        itemName: "",
        showProcessPopup: false,
        processPopupIcon: "",
        processAction: "",
        processMessage: "",
        vmDetailsPopup: false,
        singleVmData: "",
        updateFlag: false,
        cancelFlag: false,
        vmid: ""
    }


    openAddVMPopup = () => {
        this.setState(state => ({
            ...state,
            vm_name: null,
            ip_address: null,
            status: false,
            available: false,
            tasktype: 1,
            resource_group: null,
            az_subscription_id: null,
            addVMPopup: true
        }))
    }
    closeActivityPopup = () => {
        this.setState((state) => ({
            ...state,
            showProcessPopup: false,
            processMessage: null
        }))
    }


    handleSwitchChange = (event) => {
        let t = event.target;
        this.setState((state) => ({
            ...state,
            [t.name]: t.checked,
        }));
    };

    changeVMStatus = (id) => {
        API.changeVMStatus(id).then(result => {
            this.getAllVMS()
        }).catch(error => {
            console.log(error)
        })
    }

    componentWillMount() {
        document.title = "Task List - Admin";
        if (this.props.location.state) {
            let { user, type } = this.props.location.state;
            this.setState((state) => ({
                ...state,
                user,
                type
            }), async () => {
                await this.getAllVMS();
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                this.setState((state) => ({
                    ...state,
                    user,
                    type
                }), async () => {
                    await this.getAllVMS();
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    setVmValues = (vm) => {
        this.setState((state) => ({
            ...state,
            vmid: vm.id,
            vm_name: vm.az_vm_name,
            ip_address: vm.ip_address,
            status: vm.status === 'on' ? true : false,
            available: vm.available,
            tasktype: vm.tasktype,
            resource_group: vm.az_resource_group,
            az_subscription_id: vm.az_subscription_id,
            updateFlag: true,
            addVMPopup: true,
        }))
    }



    addNewVM = (event) => {
        event.preventDefault(); // to prevent default behaviour of form component
        if (!this.state.cancelFlag) {
            let { vm_name, ip_address, resource_group, az_subscription_id, status, available, tasktype } = this.state
            if (!vm_name || !ip_address || !resource_group || !az_subscription_id) {
                this.setState((state) => ({
                    ...state,
                    addVMPopup: false,
                }))
            }
            else {
                this.setState((state) => ({
                    ...state,
                    addVMPopup: false,
                    itemName: "VM",
                    processPopupIcon: "WAIT",
                    processAction: "ADD",
                    processMessage: null,
                    showProcessPopup: true,
                }))

                let newVM = {
                    "vm_name": vm_name,
                    "ip_address": ip_address,
                    "status": status ? "on" : "off",
                    "az_subscription_id": az_subscription_id,
                    "resource_group": resource_group,
                    "tasktype": tasktype,
                    "available": available
                }
                API.addNewVM(newVM).then((result) => {
                    this.setState((state) => ({
                        ...state,
                        itemName: "VM",
                        processPopupIcon: "COMPLETE",
                        processAction: "ADD",
                        processMessage: null,
                        showProcessPopup: true,
                    }), () => this.getAllVMS())
                }).catch((error) => {
                    this.setState((state) => ({
                        ...state,
                        itemName: "VM",
                        processPopupIcon: "ERROR",
                        processMessage: error.message,
                        showProcessPopup: true,
                    }))
                })
            }
        }

    }

    updateVM = (event) => {
        event.preventDefault(); // to prevent default behaviour of form component
        let { vm_name, ip_address, resource_group, az_subscription_id, status, available, tasktype } = this.state

        this.setState((state) => ({
            ...state,
            addVMPopup: false,
            itemName: "VM",
            processPopupIcon: "WAIT",
            processAction: "UPDATE",
            processMessage: null,
            showProcessPopup: true,
        }))

        let updateVM = {
            "az_vm_name": vm_name,
            "ip_address": ip_address,
            "status": status ? "on" : "off",
            "az_sub_id": az_subscription_id,
            "az_res_group": resource_group,
            "tasktype": tasktype,
            "available": available
        }
        API.updateVM(updateVM, this.state.vmid).then((result) => {
            this.setState((state) => ({
                ...state,
                itemName: "VM",
                processPopupIcon: "COMPLETE",
                processAction: "UPDATE",
                processMessage: null,
                showProcessPopup: true,
                updateFlag: false,
            }), () => this.getAllVMS())
        }).catch((error) => {
            this.setState((state) => ({
                ...state,
                itemName: "VM",
                processPopupIcon: "ERROR",
                processMessage: error.message,
                showProcessPopup: true,
                updateFlag: false,
            }))
        })
    }



    copyById = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy)
    }
    // getAll VM function starts here---------- 
    getAllVMS = async () => {
        this.setState(state => ({
            ...state,
            machineCounts: 0,
        }))
        await API.getAllVms().then(async (data) => {
            this.setState((state) => ({
                ...state,
                vms: data.vm_data,
                loading: false,
                machineCounts: data.vm_data.length
            }))
        }, (e) => {
            console.log(e);
        })
    }

    render() {
        const { vm_name, ip_address, resource_group, az_subscription_id, tasktype } = this.state;

        return (
            this.state.user && this.state.user.first_name ? <div className="wrapper">

                {/* ------------------ Vm Details Popup--------------------- */}
                <AnimatedModal
                    isOpen={this.state.vmDetailsPopup}
                    onRequestClose={() => {
                        this.setState((state) => ({
                            ...state,
                            vmDetailsPopup: false,
                        }))
                    }}
                    height="440px"
                    width="530px"
                >
                    <div style={{ textAlign: "center", margin: '10px 0px', height: '30px', fontSize: '22px', fontWeight: '500' }}>VM Details</div>
                    <img
                        src={closeButton} style={{ width: "22px", height: "22px", position: "absolute", top: "15px", right: "20px", cursor: "pointer" }} onClick={() => {
                            this.setState((state) => ({
                                ...state,
                                vmDetailsPopup: false
                            }))
                        }}></img>
                    {this.state.singleVmData ?
                        <div>
                            <div style={{ height: '5px', width: '100%' }}><hr /></div>
                            <div style={{ margin: '10px 5px', display: "flex", flexDirection: "column", width: "95%", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ margin: '1% 3%', display: "flex", width: "90%" }}>
                                    <div style={{ margin: '10px 0px', width: "35%", display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey' >VM Name</div>
                                        <div className='objectValue'>{this.state.singleVmData.az_vm_name}</div>
                                    </div>
                                    <div style={{ height: "60px", margin: "0% 4%", borderLeft: "1px solid #C8C8C8" }}></div>
                                    <div style={{ margin: '10px 0px', display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>Id</div>
                                        <div style={{ fontSize: "12px", margin: "5px 0px" }}>{this.state.singleVmData.id}</div>
                                    </div>
                                </div>
                                <div style={{ margin: '1% 3%', display: "flex", width: "90%" }}>
                                    <div style={{ margin: '10px 0px', width: "35%", display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>Resource group</div>
                                        <div className='objectValue'>{this.state.singleVmData.az_resource_group}</div>
                                    </div>
                                    <div style={{ height: "60px", margin: "2% 4% 0% 4%", borderLeft: "1px solid #C8C8C8" }}></div>
                                    <div style={{ margin: '10px 0px', display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey' >Subscription Id</div>
                                        <div style={{ fontSize: "12px", margin: "5px 0px" }}>{this.state.singleVmData.az_subscription_id}</div>
                                    </div>
                                </div>

                                <div style={{ margin: '1% 3%', display: "flex", width: "90%" }}>
                                    <div style={{ margin: '10px 0px', width: "35%", display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>IP address</div>
                                        <div className='objectValue'>{this.state.singleVmData.ip_address}</div>
                                    </div>
                                    <div style={{ height: "60px", margin: "2% 4% 0% 4%", borderLeft: "1px solid #C8C8C8" }}></div>
                                    <div style={{ margin: '10px 5px', display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>Status</div>
                                        <div className='objectValue'>{this.state.singleVmData.status}</div>
                                    </div>
                                </div>

                                <div style={{ margin: '1% 3%', display: "flex", width: "90%" }}>
                                    <div style={{ margin: '10px 0px', width: "35%", display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>Task type</div>
                                        <div className='objectValue'>{this.state.singleVmData.tasktype == 1 ? "Training" :
                                            this.state.singleVmData.tasktype == 2 ? "Detection" :
                                                this.state.singleVmData.tasktype == 3 ? "Orthomosaic" : "-"}</div>
                                    </div>
                                    <div style={{ height: "60px", margin: "2% 4% 0% 4%", borderLeft: "1px solid #C8C8C8" }}></div>
                                    <div style={{ margin: '10px 5px', display: "flex", flexDirection: "column" }}>
                                        <div className='objectKey'>Available</div>
                                        <div className='objectValue'>{this.state.singleVmData.available ? "Yes" : "No"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <></>
                    }

                </AnimatedModal>

                <AnimatedModal
                    isOpen={this.state.addVMPopup}
                    onRequestClose={() => {
                        this.setState((state) => ({
                            ...state,
                            addVMPopup: false,
                            updateFlag: false
                        }))
                    }}
                    height="550px"
                    width="550px"
                >
                    <div className='content-text' style={{ textAlign: "center", margin: '10px 0px', height: '30px', fontSize: '20px', fontWeight: '500' }}>{this.state.updateFlag ? "Update Virtual Machine" : "Add New Virtual Machine"}</div>
                    <div style={{ height: '5px', width: '100%' }}><hr /></div>
                    <form onSubmit={this.state.updateFlag ? this.updateVM : this.addNewVM} >
                        <div style={{ margin: '10px 50px' }}>
                            <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "1%" }}>VM Name</div>
                            <div className="add-user-form-text-wrapper">
                                <input
                                    className="sub-add-user-form-text"
                                    type="text"
                                    name="vm_name"
                                    placeholder="Enter VM Name"
                                    onChange={(e) => { this.setState({ vm_name: e.target.value }) }}
                                    value={vm_name}
                                />
                            </div>
                            <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "2%" }}>IP address</div>
                            <div className="add-user-form-text-wrapper">
                                <input
                                    className="sub-add-user-form-text"
                                    type="text"
                                    name="ip_address"
                                    placeholder="e.g. 0.0.0.0 to 255.255.255.255"
                                    onChange={(e) => { this.setState({ ip_address: e.target.value }) }}
                                    value={ip_address}
                                    pattern='\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b'
                                />
                            </div>
                            <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "2%" }}>Resource group</div>
                            <div className="add-user-form-text-wrapper">
                                <input
                                    className="sub-add-user-form-text"
                                    type="text"
                                    name="resource_group"
                                    placeholder="Enter Resource Group"
                                    onChange={(e) => { this.setState({ resource_group: e.target.value }) }}
                                    value={resource_group}
                                />
                            </div>
                            <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "2%" }}>Azure Subscription ID</div>
                            <div className="add-user-form-text-wrapper">
                                <input
                                    className="sub-add-user-form-text"
                                    type="text"
                                    name="az_subscription_id"
                                    placeholder="Enter Azure Subscription Id"
                                    onChange={(e) => { this.setState({ az_subscription_id: e.target.value }) }}
                                    value={az_subscription_id}
                                />
                            </div>
                            <div style={{ display: "flex", marginTop: "4%", justifyContent: "space-between" }}>
                                <div>
                                    <div className='sub-add-user-form-label' style={{ display: "flex" }}>Server Type</div>
                                    <select
                                        className="sub-add-user-form-text"
                                        style={{ width: "200px", borderRadius: "5px", fontSize: "12px" }}
                                        name='tasktype'
                                        value={tasktype}
                                        onChange={(e) => { this.setState({ tasktype: e.target.value }) }}
                                    >
                                        <option value={1}>Streaming Server</option>
                                        <option value={2}>AE Server</option>
                                    </select>
                                </div>
                                <div>
                                    <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "2%" }}>Status</div>
                                    <Switch label="Status" onChange={(e) => this.handleSwitchChange(e)} name="status" checked={this.state.status} />
                                </div>
                                <div>
                                    <div className='sub-add-user-form-label' style={{ display: "flex", marginTop: "2%" }}>Available</div>
                                    <Switch label="Status" onChange={(e) => this.handleSwitchChange(e)} name="available" checked={this.state.available} />
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: '50px 50px 10px 50px', display: 'flex', justifyContent: 'space-between' }}>
                            <button className="addcustomer-button-empty-dashboard popup-btn-left"
                                onClick={() => {
                                    this.setState((state) => ({
                                        ...state,
                                        addVMPopup: false,
                                        updateFlag: false,
                                        cancelFlag: true
                                    }));
                                }}
                            >Cancel</button>
                            {this.state.updateFlag ? <button className="add-user-form-submit-button popup-btn-right btn-ok" type='submit'>Update</button>
                                : vm_name && ip_address && resource_group && az_subscription_id ? <button className="add-user-form-submit-button popup-btn-right btn-ok" type='submit'>Add</button>
                                    : <button disabled style={{ opacity: '0.5' }} className="add-user-form-submit-button popup-btn-right btn-ok">Add</button>}

                        </div>
                    </form>
                </AnimatedModal>

                {/* --------------Activity Popup ----------------------- */}

                <ActivityPopup item={this.state.itemName} open={this.state.showProcessPopup} icon={this.state.processPopupIcon} action={this.state.processAction} msg={this.state.processMessage} close={() => this.closeActivityPopup()} />

                {/* --------------------------------------------------------------- */}

                <div className="right-content-new" style={{ zIndex: 0 }} >
                    <div className="top-bar-new" style={{ display: "flex" }}><div className="top-bar-text-new">Machines</div>
                    </div>
                    <div className="main-content">
                        <div style={{ marginTop: "10px", display: "flex", width: "100%", justifyContent: "space-between" }}>
                            <div className="services-content-title"> Virtual Machines : {this.state.machineCounts}</div>
                            <div className="add-user-form-text-wrapper" style={{ marginLeft: "25px", marginRight: '5px' }}>
                                <img src={btnAdd} style={{ height: '30px', width: '34px', cursor: 'pointer' }} onClick={() => this.openAddVMPopup()} />
                            </div>
                        </div>
                        {this.state.loading ? (
                            <div style={{ height: "85vh", width: "91vw", display: "flex", textAlign: "center" }}>
                                <img src={Loader} style={{ height: "20vh", width: "100vw", margin: "auto" }} />
                            </div>) : (
                            <table className="customers-table">
                                <tr className="customers-table-header-row" style={{ position: "inherit" }}>
                                    <th>IP address</th>
                                    <th>Edit</th>
                                    <th>Name</th>
                                    <th>Resource Group</th>
                                    <th>Status</th>
                                    <th>Available</th>
                                    <th>Server Type</th>
                                </tr>
                                {this.state.vms.length === 0 ?
                                    <tr className="customers-table-data-row" align="center" style={{ height: "45px" }}>
                                        <td colspan="6">No Machines Available</td>
                                    </tr> :
                                    this.state.vms.map((vm, i) =>
                                        <tr className="customers-table-data-row" style={{ height: "45px" }} >
                                            <td onClick={() => {
                                                this.setState((state) => ({
                                                    ...state,
                                                    singleVmData: vm,
                                                    vmDetailsPopup: true
                                                }))
                                            }} style={{ cursor: "pointer" }}>{vm.ip_address} </td>
                                            <td><img src={Edit} onClick={() => {
                                                this.setVmValues(vm)
                                            }} style={{ marginLeft: "5px", height: '14px', width: "14px", cursor: "pointer" }} /></td>
                                            <td onClick={() => {
                                                this.setState((state) => ({
                                                    ...state,
                                                    singleVmData: vm,
                                                    vmDetailsPopup: true
                                                }))
                                            }} style={{ cursor: "pointer" }}>{vm.az_vm_name}</td>
                                            <td onClick={() => {
                                                this.setState((state) => ({
                                                    ...state,
                                                    singleVmData: vm,
                                                    vmDetailsPopup: true
                                                }))
                                            }} style={{ cursor: "pointer" }}>{vm.az_resource_group}</td>
                                            <td>{vm.status}</td>
                                            <td>
                                                <Switch onClick={() => { this.changeVMStatus(vm.id) }} checked={vm.available} />
                                            </td>
                                            <td>
                                                {
                                                    (() => {
                                                        return `${vm.tasktype == 1 ? 'Streaming Server' : vm.tasktype == 2 ? 'Backend Server' : 'Other'}`
                                                    })()
                                                }
                                            </td>
                                        </tr>
                                    )}
                            </table>
                        )
                        }
                    </div>
                </div>
            </div > : <div style={{ height: "85vh", width: "91vw", display: "flex", textAlign: "center" }}>
                <img src={Loader} style={{ height: "30vh", width: "100vw", margin: "auto" }} />
            </div>
        );
    }
}
